import React, {useState} from 'react';
import Modal from 'shared/components/modal';
import Image1 from 'shared/img/student-welcome-image-1.svg';
import Image2 from 'shared/img/student-welcome-image-2.svg';
import Image3 from 'shared/img/student-welcome-image-3.svg';

type SvgComponent = React.FC<React.SVGProps<SVGSVGElement>>;

interface Props {
  handleClose: () => void;
}

interface ModalContent {
  title: string;
  text: string;
  ModalImage: SvgComponent;
}

function StudentWelcomeModal({handleClose}: Props): React.ReactElement {
  const [step, setStep] = useState<number>(0);

  const onNextClick = (): void => {
    if (step === 2) {
      handleClose();
    } else {
      setStep(step + 1);
    }
  };

  const onBackClick = (): void => {
    setStep(step - 1);
  };

  const getModalContent = (): ModalContent => {
    const modalContent = {} as ModalContent;

    switch (step) {
      case 0:
        modalContent.title = 'Welcome to the Raise Me Dashboard';
        modalContent.text =
          'Explore the Raise Me dashboard, your central hub for managing checklist items, completing tasks, and earning ' +
          "Micro-scholarships. In addition, the dashboard is also the space where you'll find the widget section that " +
          'you can use to explore Raise Me.';
        modalContent.ModalImage = Image1;

        break;
      case 1:
        modalContent.title = 'Explore Raise Me';
        modalContent.text =
          'Explore Raise Me by using the widget tiles, these take you to essential pages such as your portfolio, ' +
          'checklist, college search, and beyond.';
        modalContent.ModalImage = Image2;
        break;
      case 2:
        modalContent.title = 'Your Portfolio';
        modalContent.text =
          'Ensure to visit your portfolio page and complete it to maximize your earnings.';
        modalContent.ModalImage = Image3;
        break;
    }

    return modalContent;
  };

  const {ModalImage, title, text} = getModalContent();
  const secondaryButton = step === 0 ? undefined : {onClick: onBackClick, text: 'Back', width: 85};

  return (
    <Modal show className="welcome-modal" onClose={() => handleClose()}>
      <Modal.ImageHeader
        onClose={() => handleClose()}
        backgroundImage={ModalImage}
        backgroundColor="r500"
        color="white"
        height="tall"
      >
        {title}
      </Modal.ImageHeader>
      <Modal.Body>
        <p className="college-search-welcome-modal-text">{text}</p>
      </Modal.Body>
      <Modal.NavigationFooter
        primaryButton={{
          onClick: onNextClick,
          width: 85,
          text: step === 2 ? 'Done' : 'Next',
        }}
        stepCount={3}
        currentStep={step}
        secondaryButton={secondaryButton}
      />
    </Modal>
  );
}

export default StudentWelcomeModal;
